/**
 * src/admin-ui/src/App.tsx
 *
 * Application providers and route definitions.
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AuthProvider from './components/AuthProvider';
import ErrorBoundary from './components/ErrorBoundary';
// RedirectDebug показывает всплывашку при циклах редиректов; подключаем только в разработке
import RedirectDebug from './components/RedirectDebug';
import ApiKeys from './pages/ApiKeys';
import Billing from './pages/Billing';
import ModelPricing from './pages/ModelPricing';
import ModelUsageAnalytics from './pages/ModelUsageAnalytics';
import AdminUsers from './pages/AdminUsers';
import { ColorModeProvider } from './theme/ColorModeProvider';
import AppShell from './components/AppShell';

function App() {
  return (
    <ErrorBoundary>
      <ColorModeProvider>
        <AuthProvider>
          <Router>
            {process.env.NODE_ENV !== 'production' && <RedirectDebug />}
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <Dashboard />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/api-keys"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <ApiKeys />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/billing"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <Billing />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/pricing"
                element={
                  <AdminRoute>
                    <AppShell>
                      <ModelPricing />
                    </AppShell>
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/model-usage"
                element={
                  <AdminRoute>
                    <AppShell>
                      <ModelUsageAnalytics />
                    </AppShell>
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/users"
                element={
                  <AdminRoute>
                    <AppShell>
                      <AdminUsers />
                    </AppShell>
                  </AdminRoute>
                }
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Router>
        </AuthProvider>
      </ColorModeProvider>
    </ErrorBoundary>
  );
}

export default App;
